import * as actions from '../actions/actionsTypes';

const pageTitle = (state='', action) => {
  if (action.type === actions.SET_TITLE){
    return action.value
  }
  return state
}

export default pageTitle